var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top",style:(_vm.BlueListincludes?'color:var( --text-color);':'')},[_c('van-icon',{staticStyle:{"transform":"rotate(90deg)"},attrs:{"name":"down"},on:{"click":function($event){return _vm.toprouter()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }